import { useLocale } from '../../../../shared/i18n/locale/useLocale';
import { getMapUrlForPoiId } from '../../../../shop-dine-and-relax/ui/detail/helpers/getMapUrlForPoiId';
import { ICheckpointQueue } from '../../../domain/models/ICheckpointQueue';

export function useCheckpointUrl(checkpointQueue: ICheckpointQueue) {
	const currentLocale = useLocale();

	if (!checkpointQueue.poiId) {
		return undefined;
	}

	return getMapUrlForPoiId(currentLocale, checkpointQueue.poiId);
}
